import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface MissingRoleRateDialogProps {
  onAddRate: () => void;
  onCancel: () => void;
  open: boolean;
  roleName?: string;
}

const MissingRoleRateDialog: React.FC<MissingRoleRateDialogProps> = ({
  onAddRate,
  onCancel,
  open,
  roleName,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Rate Required</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          {`No  rate  exists for ${roleName || "this role"}. Add a rate first, or cancel this assignment.`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={onAddRate}>
          Add Rate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MissingRoleRateDialog;
